export function calculateTotal(selectedPackages, extraIds, allExtras) {
  const packagesTotal = (selectedPackages || []).reduce((sum, p) => sum + (p.price || 0), 0);
  const extrasTotal = (extraIds || []).reduce((sum, id) => {
    const extra = (allExtras || []).find((e) => e.id === id);
    return sum + (extra?.price || 0);
  }, 0);
  return packagesTotal + extrasTotal;
}

export function normalizeCity(value) {
  return (value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function matchTravelCost(city, travelCosts) {
  const normalized = normalizeCity(city);
  if (!normalized) return null;
  return (travelCosts || []).find((t) => normalizeCity(t.city) === normalized) || null;
}

export function isLocalCity(city) {
  return normalizeCity(city) === "queretaro";
}
